module.exports = __webpack_public_path__ + "img/ico-pinterest-circle.9115fc5c.png";